export default "__VITE_ASSET__BBkxxinr__"